import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import FileCard from './file_card';

export class FilePanel extends React.Component {
  static propTypes = {
    files: PropTypes.object.isRequired
  }

  renderFileCards() {
    const { files } = this.props;
    return Object.values(files).map((file) => {
      return <FileCard file={file} key={file.id} />;
    });
  }

  render() {
    const { files } = this.props;

    const title = Object.keys(files).length > 1 ? "Files" : "File";

    return (
      <div className="mv-4 mh-5">
        <div className="mb-2">
          <strong>{Object.keys(files).length} {title} Uploaded</strong>
        </div>
        {this.renderFileCards()}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  files: state.importObject.files
});

export default connect(mapStateToProps)(FilePanel);